import type { PostType } from "@sorcery/cms";
import { H2 } from "@sorcery/ui";

import { PostPreview } from "./preview/PostPreview";

export const MorePosts = ({
  posts,
  header,
}: {
  posts: PostType[];
  header?: string;
}) => {
  return (
    <>
      <H2 className="mb-8 text-center sm:text-left">{header ?? "More Articles"}</H2>

      <div className="grid grid-cols-1 gap-y-12 md:grid-cols-2 md:gap-x-8 md:gap-y-12 lg:gap-x-16">
        {posts.map((post) => (
          <PostPreview key={post._id} post={post} />
        ))}
      </div>
    </>
  );
};
